"use client";

import { ReactNode } from "react";
import { Dialog as MuiDialog } from "@mui/material";
import { useUnassignDialog } from "../Providers/UnassignDialogContext";

interface DialogProps {
  children: ReactNode;
}

export default function Dialog({ children }: DialogProps) {
  const { unassignDialogOpen, closeUnassignDialog, setUserRowSelectionModel } =
    useUnassignDialog();

  const handleClose = () => {
    setUserRowSelectionModel({
      ids: new Set([]),
      type: "include",
    });
    closeUnassignDialog();
  };

  return (
    <MuiDialog fullWidth open={unassignDialogOpen} onClose={handleClose}>
      {children}
    </MuiDialog>
  );
}
